import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../utils/axios";
import { API_ROUTES } from "./routes";

// Get all page visits
export const useGetPageVisitsQuery = (type) => {
  const { data, isPending, isError, error } = useQuery({
    queryKey: [API_ROUTES.GET_PAGE_VISITS],
    queryFn: () => api.get(API_ROUTES.GET_PAGE_VISITS, { params: { type } }),
  });

  return {
    data: data?.data?.data ?? [],
    isPending,
    isError,
    error,
  };
};
